import { coreApi } from '.';
import type {
  CreateDashboardReq,
  CreateDashboardRes,
  DeleteDashboardByIdReq,
  GetDashboardByIdReq,
  GetDashboardKpiReq,
  GetDashboardRes,
  GetDashboardKPIRes,
  GetDashboardUserRes,
  UpdateDashboardByIdReq,
  UpdateDashboardByIdRes,
} from 'types/dashboard';
import { TAG_TYPES } from 'types/services';

export const dashboardService = coreApi.injectEndpoints({
  endpoints: (builder) => ({
    getDashboard: builder.query<GetDashboardRes, void>({
      query: () => ({
        url: 'Dashboards',
        method: 'GET',
      }),
      providesTags: [TAG_TYPES.DASHBOARD],
    }),
    getDashboardById: builder.query<GetDashboardRes, GetDashboardByIdReq>({
      query: (data) => ({
        url: `Dashboards/${data.id}/Definition`,
        method: 'GET',
      }),
      providesTags: [TAG_TYPES.DASHBOARD],
    }),
    getDashboardUser: builder.query<GetDashboardUserRes, GetDashboardByIdReq>({
      query: (data) => ({
        url: `Dashboards/${data.id}/user`,
        method: 'GET',
      }),
      providesTags: [TAG_TYPES.DASHBOARD],
    }),
    getDashboardAdmin: builder.query<GetDashboardUserRes, void>({
      query: () => ({
        url: `Dashboards/admin`,
        method: 'GET',
      }),
      providesTags: [TAG_TYPES.DASHBOARD],
    }),
    getDashboardKPI: builder.query<GetDashboardKPIRes, GetDashboardKpiReq>({
      queryFn: async (arg, _, __, baseQuery) => {
        const result = await baseQuery({
          url: `Dashboards/Kpi`,
          method: 'GET',
          params: arg,
        });

        if (result.error) {
          const isHelios = Boolean(arg.heliosScript || arg.heliosDataSource);

          if (isHelios) {
            return {
              data: { textToDisplay: '', link: '', valueToDisplay: '' },
            };
          }

          return { error: result.error };
        }

        return { data: result.data as GetDashboardKPIRes };
      },
      providesTags: [TAG_TYPES.DASHBOARD],
    }),
    createDashboard: builder.mutation<CreateDashboardRes, CreateDashboardReq>({
      query: (data) => ({
        url: `Dashboards`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [TAG_TYPES.MODULES, TAG_TYPES.DASHBOARD],
    }),
    updateDashboardById: builder.mutation<UpdateDashboardByIdRes, UpdateDashboardByIdReq>({
      query: (data) => ({
        url: `Dashboards/${data.dashboardId}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: [TAG_TYPES.MODULES, TAG_TYPES.DASHBOARD],
    }),
    deleteDashboardById: builder.mutation<void, DeleteDashboardByIdReq>({
      query: (data) => ({
        url: `Dashboards/${data.id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [TAG_TYPES.MODULES, TAG_TYPES.DASHBOARD],
    }),
    deleteDashboardMe: builder.mutation<void, void>({
      query: () => ({
        url: `Dashboards/Me/RemoveAll`,
        method: 'DELETE',
      }),
      invalidatesTags: [TAG_TYPES.MODULES, TAG_TYPES.DASHBOARD],
    }),
  }),
});
export const {
  useGetDashboardQuery,
  useGetDashboardByIdQuery,
  useLazyGetDashboardByIdQuery,
  useCreateDashboardMutation,
  useUpdateDashboardByIdMutation,
  useDeleteDashboardByIdMutation,
  useDeleteDashboardMeMutation,
  useGetDashboardAdminQuery,
  useGetDashboardUserQuery,
  useGetDashboardKPIQuery,
} = dashboardService;
